const AppActions = {
  APP_MOUNTED: 'app/mounted',
  APP_AUTH_RESET: 'app/authReset',
  FETCH_TRANSLATIONS: 'translations/fetch',
  APP_SIGN_OUT: 'app/signOut',
  VALIDATE_AUTH_TOKEN: 'app/validate-auth-token',
};

export {
  AppActions,
};
